export default {
    meta: {
        titleTemplate: "Le mois de l'économie sociale",
        description:
            "Durant le mois de novembre, faites connaissance avec l'économie sociale. Apprenez quelles sont ses retombées économiques et sociales partout au Québec.",
    },
    global: {
        date: "1<sup>er</sup> au 30 Novembre",
        pressKit: "Dossier de presse",
        gotQuestions: "Pour toute question",
    },
    btn: {
        more: "En savoir plus",
        discover: `Découvrir l'`,
        allEconomies: "Tous les types d’économies",
        allStories: "Retour",
        downloadKit: "Télécharger le dossier",
        storyBehind: "Découvrez son histoire",
    },
    nav: {
        campaigns: "Campagnes",
        info: "Infos utiles",
    },
    shared: {
        locales: {
            en: "Anglais",
            fr: "Français",
        },
        cursor: {
            watch: "Regarder",
        },
    },
};
